// extracted by mini-css-extract-plugin
module.exports = {"control":"usePaginationControls_control__b9DaJ","right":"usePaginationControls_right__v64My","left":"usePaginationControls_left__uDZvN"};